export const GET_DASHBOARD_DATA_ORM = "GET_DASHBOARD_DATA_ORM";
export const GET_PROJECT_FILTER_ORM = "GET_PROJECT_FILTER_ORM";
export const GET_RESPONSIBLE_FILTER_ORM = "GET_RESPONSIBLE_FILTER_ORM";
export const GET_ACCOUNTABLE_FILTER_ORM = "GET_ACCOUNTABLE_FILTER_ORM";
export const GET_PROJECT_BD_OWNER_FILTER_ORM = "GET_PROJECT_BD_OWNER_FILTER_ORM";
export const GET_PROJECT_PROPOSAL_OWNER_FILTER_ORM = "GET_PROJECT_PROPOSAL_OWNER_FILTER_ORM";
export const GET_LIAISON_PROCESS_SUMMARY_ORM = "GET_LIAISON_PROCESS_SUMMARY_ORM";
export const GET_LIAISON_PROCESS_SUMMARY_ORM_EXPORT = "GET_LIAISON_PROCESS_SUMMARY_ORM_EXPORT";
export const GET_LIAISON_PROCESS_ORM = "GET_LIAISON_PROCESS_ORM";
export const GET_LIAISON_PROCESS_ORM_EXPORT = "GET_LIAISON_PROCESS_ORM_EXPORT";
export const GET_LIAISON_TASK_PLAN_ORM = "GET_LIAISON_TASK_PLAN_ORM";
export const GET_LIAISON_TASK_PLAN_ORM_EXPORT = "GET_LIAISON_TASK_PLAN_ORM_EXPORT";
export const GET_LIAISON_PROCESS_DATA_ORM = "GET_LIAISON_PROCESS_DATA_ORM";
export const GET_LIAISON_DOCUMENTATION_DATA_ORM = "GET_LIAISON_DOCUMENTATION_DATA_ORM";
export const GET_LIAISON_DOCUMENTATION_SUMMARY_ORM = "GET_LIAISON_DOCUMENTATION_SUMMARY_ORM";
export const GET_LIAISON_DOCUMENTATION_SUMMARY_ORM_EXPORT =
  "GET_LIAISON_DOCUMENTATION_SUMMARY_ORM_EXPORT";
export const GET_LIAISON_DOCUMENTATION_ORM = "GET_LIAISON_DOCUMENTATION_ORM";
export const GET_LEGAL_DATA_ORM = "GET_LEGAL_DATA_ORM";
export const GET_LEGAL_SUMMARY_ORM = "GET_LEGAL_SUMMARY_ORM";
export const GET_LEGAL_ORM = "GET_LEGAL_ORM";
export const GET_LEGAL1_DATA_ORM = "GET_LEGAL1_DATA_ORM";
export const GET_LEGAL1_SUMMARY_ORM = "GET_LEGAL1_SUMMARY_ORM";
export const GET_LEGAL1_ORM = "GET_LEGAL1_ORM";
export const GET_COURT_CASE_DATA_ORM = "GET_COURT_CASE_DATA_ORM";
export const GET_COURT_CASE_SUMMARY_ORM = "GET_COURT_CASE_SUMMARY_ORM";
export const GET_COURT_CASE_ORM = "GET_COURT_CASE_ORM";
export const GET_PROJECT_PROGRESS_DASHBOARD_ORM = "GET_PROJECT_PROGRESS_DASHBOARD_ORM";
export const GET_BUSINESS_DEVELOPMENT_DATA_ORM = "GET_BUSINESS_DEVELOPMENT_DATA_ORM";
export const GET_BUSINESS_DEVELOPMENT_DATA_ORM_EXPORT = "GET_BUSINESS_DEVELOPMENT_DATA_ORM_EXPORT";
export const GET_BUSINESS_DEVELOPMENT_DATA_ORM1 = "GET_BUSINESS_DEVELOPMENT_DATA_ORM1";
export const GET_BUSINESS_DEVELOPMENT_ORM = "GET_BUSINESS_DEVELOPMENT_ORM";
export const GET_PROJECT_PLAN_DELAY_REASON = "GET_PROJECT_PLAN_DELAY_REASON";
export const GET_PROJECT_PLAN_CHANGE_HISTORY = "GET_PROJECT_PLAN_CHANGE_HISTORY";

// ORM Sales
export const GET_SALES_DATA_ORM = "GET_SALES_DATA_ORM";
export const GET_SALES_SUMMARY_ORM = "GET_SALES_SUMMARY_ORM";
export const GET_SALES_ORM = "GET_SALES_ORM";
// CP Sales
export const GET_CP_SALES_DATA_ORM = "GET_CP_SALES_DATA_ORM";
export const GET_CP_SALES_SUMMARY_ORM = "GET_CP_SALES_SUMMARY_ORM";
export const GET_CP_SALES_ORM = "GET_CP_SALES_ORM";
// Pre Sales
export const GET_PRE_SALES_DATA_ORM = "GET_PRE_SALES_DATA_ORM";
export const GET_PRE_SALES_SUMMARY_ORM = "GET_PRE_SALES_SUMMARY_ORM";
export const GET_PRE_SALES_ORM = "GET_PRE_SALES_ORM";
// Cancellation Sales
export const GET_CANCELLATION_SALES_DATA_ORM = "GET_CANCELLATION_SALES_DATA_ORM";
export const GET_CANCELLATION_SALES_SUMMARY_ORM = "GET_CANCELLATION_SALES_SUMMARY_ORM";
export const GET_CANCELLATION_SALES_ORM = "GET_CANCELLATION_SALES_ORM";
//Collection Sales
export const GET_COLLECTION_DATA_ORM = "GET_COLLECTION_DATA_ORM";
export const GET_COLLECTION_SUMMARY_ORM = "GET_COLLECTION_SUMMARY_ORM";
export const GET_COLLECTION_ORM = "GET_COLLECTION_ORM";
export const GET_COLLECTION_ORM_EXPORT = "GET_COLLECTION_ORM_EXPORT";
export const GET_COLLECTION_OUTSTANDING = "GET_COLLECTION_OUTSTANDING";
export const GET_COLLECTION_OUTSTANDING_INFO = "GET_COLLECTION_OUTSTANDING_INFO";

//Agreement Sales
export const GET_AGREEMENT_DATA_ORM = "GET_AGREEMENT_DATA_ORM";
export const GET_AGREEMENT_SUMMARY_ORM = "GET_AGREEMENT_SUMMARY_ORM";
export const GET_AGREEMENT_SUMMARY_ORM_EXPORT = "GET_AGREEMENT_SUMMARY_ORM_EXPORT";
export const GET_AGREEMENT_ORM = "GET_AGREEMENT_ORM";
export const GET_AGREEMENT_ORM_CARD = "GET_AGREEMENT_ORM_CARD";
export const GET_AGREEMENT_ORM_EXPORT = "GET_AGREEMENT_ORM_EXPORT";

//Registration Sales
export const GET_REGISTRATION_DATA_ORM = "GET_REGISTRATION_DATA_ORM";
export const GET_REGISTRATION_SUMMARY_ORM = "GET_REGISTRATION_SUMMARY_ORM";
export const GET_REGISTRATION_SUMMARY_ORM_EXPORT = "GET_REGISTRATION_SUMMARY_ORM_EXPORT";
export const GET_REGISTRATION_ORM = "GET_REGISTRATION_ORM";
export const GET_REGISTRATION_ORM_CARD = "GET_REGISTRATION_ORM_CARD";
export const GET_REGISTRATION_ORM_EXPORT = "GET_REGISTRATION_ORM_EXPORT";
//Customer
export const GET_CUSTOMER_DATA_ORM = "GET_CUSTOMER_DATA_ORM";
export const GET_CUSTOMER_SUMMARY_ORM = "GET_CUSTOMER_SUMMARY_ORM";
export const GET_CUSTOMER_ORM = "GET_CUSTOMER_ORM";
//Marketting
export const GET_MARKETING_DATA_ORM = "GET_MARKETING_DATA_ORM";
export const GET_MARKETING_SUMMARY_ORM = "GET_MARKETING_SUMMARY_ORM";
export const GET_MARKETING_ORM = "GET_MARKETING_ORM";
export const GET_MARKETING_COST_PER_LEAD_DATA_ORM = "GET_MARKETING_COST_PER_LEAD_DATA_ORM";
export const GET_MARKETING_COST_PER_SITE_VISIT_DATA_ORM =
  "GET_MARKETING_COST_PER_SITE_VISIT_DATA_ORM";
export const GET_MARKETING_COST_PER_SALES_DATA_ORM = "GET_MARKETING_COST_PER_SALES_DATA_ORM";

//Marketting Funnel
export const GET_MARKETING_FUNNEL_DATA_ORM = "GET_MARKETING_FUNNEL_DATA_ORM";
export const GET_MARKETING_FUNNEL_SUMMARY_ORM = "GET_MARKETING_FUNNEL_SUMMARY_ORM";
export const GET_MARKETING_FUNNEL_ORM = "GET_MARKETING_FUNNEL_ORM";
export const GET_MARKETING_LEADS_BY_CATEGORY_ORM = "GET_MARKETING_LEADS_BY_CATEGORY_ORM";
export const GET_MARKETING_LEADS_BY_SOURCE_ORM = "GET_MARKETING_LEADS_BY_SOURCE_ORM";
export const GET_MARKETING_LEADS_BY_SUB_SOURCE_ORM = "GET_MARKETING_LEADS_BY_SUB_SOURCE_ORM";
export const GET_MARKETING_LEADS_BY_PROJECT_ORM = "GET_MARKETING_LEADS_BY_PROJECT_ORM";
export const GET_MARKETING_COST_SUMMARY_ORM = "GET_MARKETING_COST_SUMMARY_ORM";

export const GET_SURVEY_DATA_ORM = "GET_SURVEY_DATA_ORM";
export const GET_SURVEY_SUMMARY_ORM = "GET_SURVEY_SUMMARY_ORM";
export const GET_SURVEY_ORM = "GET_SURVEY_ORM";
export const GET_PROJECT_HANDOVER_DATA_ORM = "GET_PROJECT_HANDOVER_DATA_ORM";
export const GET_PROJECT_HANDOVER_SUMMARY_ORM = "GET_PROJECT_HANDOVER_SUMMARY_ORM";
export const GET_PROJECT_HANDOVER_ORM = "GET_PROJECT_HANDOVER_ORM";
// BD Action ORM
export const GET_ACTION_FOR_BD = "GET_ACTION_FOR_BD";
// Liaison Process
export const GET_ACTION_FOR_LIAISON_PROCESS = "GET_ACTION_FOR_LIAISON_PROCESS";
// Liaison Documentation
export const GET_ACTION_FOR_LIAISON_DOCUMENTATION = "GET_ACTION_FOR_LIAISON_DOCUMENTATION";
// Survey
export const GET_ACTION_FOR_SURVEY = "GET_ACTION_FOR_SURVEY";
// Boundary Dispute
export const GET_ACTION_FOR_BOUNDARY_DISPUTE = "GET_ACTION_FOR_BOUNDARY_DISPUTE";
// Court Case
export const GET_ACTION_FOR_COURT_CASE = "GET_ACTION_FOR_COURT_CASE";
// Legal Task
export const GET_ACTION_FOR_LEGAL_TASK = "GET_ACTION_FOR_LEGAL_TASK";
export const GET_ACTION_FOR_ERP = "GET_ACTION_FOR_ERP";
// Marketing Action ORM
export const GET_ACTION_FOR_MARKETING = "GET_ACTION_FOR_MARKETING";
export const GET_ACTION_FOR_PRE_SALES = "GET_ACTION_FOR_PRE_SALES";
export const GET_ACTION_FOR_SALES = "GET_ACTION_FOR_SALES";
export const GET_ACTION_FOR_CP_SALES = "GET_ACTION_FOR_CP_SALES";
export const GET_ACTION_FOR_CANCELLATION = "GET_ACTION_FOR_CANCELLATION";
export const GET_ACTION_FOR_AGREEMENT = "GET_ACTION_FOR_AGREEMENT";
export const GET_ACTION_FOR_COLLECTION = "GET_ACTION_FOR_COLLECTION";
export const GET_ACTION_FOR_REGISTRATION = "GET_ACTION_FOR_REGISTRATION";
export const GET_ACTION_FOR_CUSTOMER_TICKET = "GET_ACTION_FOR_CUSTOMER_TICKET";
export const GET_ACTION_FOR_PROJECT_HANDOVER = "GET_ACTION_FOR_PROJECT_HANDOVER";

//Procurement ORM
export const GET_PROCUREMENT_DATA_ORM = "GET_PROCUREMENT_DATA_ORM";
export const GET_PROCUREMENT_SUMMARY_ORM = "GET_PROCUREMENT_SUMMARY_ORM";
export const GET_PROCUREMENT_ORM = "GET_PROCUREMENT_ORM";
export const GET_STORE_DATA_ORM = "GET_STORE_DATA_ORM";
export const GET_STORE_SUMMARY_ORM = "GET_STORE_SUMMARY_ORM";
export const GET_STORE_ORM = "GET_STORE_ORM";
//Action For Procurement
export const GET_ACTION_FOR_PROCUREMENT_PLAN = "GET_ACTION_FOR_PROCUREMENT_PLAN";
export const GET_ACTION_FOR_STOCK_SUMMARY = "GET_ACTION_FOR_STOCK_SUMMARY";

export const GET_PROCURMENT_OUTSTANDING_DATA_ORM = "GET_PROCURMENT_OUTSTANDING_DATA_ORM";
export const GET_PROCURMENT_OUTSTANDING_SUMMARY_ORM = "GET_PROCURMENT_OUTSTANDING_SUMMARY_ORM";
export const GET_PROCURMENT_OUTSTANDING_SUMMARY_ORM_EXPORT =
  "GET_PROCURMENT_OUTSTANDING_SUMMARY_ORM_EXPORT";
export const GET_PROCURMENT_OUTSTANDING_ORM = "GET_PROCURMENT_OUTSTANDING_ORM";
export const GET_PROCURMENT_OUTSTANDING_ORM_EXPORT = "GET_PROCURMENT_OUTSTANDING_ORM_EXPORT";
export const GET_PROCURMENT_OUTSTANDING_DATA_ORM_FILTER_COMPANY =
  "GET_PROCURMENT_OUTSTANDING_DATA_ORM_FILTER_COMPANY";
export const GET_PROCURMENT_OUTSTANDING_DATA_ORM_FILTER_CATEGORY =
  "GET_PROCURMENT_OUTSTANDING_DATA_ORM_FILTER_CATEGORY";
export const GET_PROCURMENT_OUTSTANDING_DATA_ORM_FILTER_VENDOR =
  "GET_PROCURMENT_OUTSTANDING_DATA_ORM_FILTER_VENDOR";
export const GET_PROCURMENT_OUTSTANDING_DATA_ORM_FILTER_PROJECT =
  "GET_PROCURMENT_OUTSTANDING_DATA_ORM_FILTER_PROJECT";

export const GET_PAYMENT_DATA_ORM = "GET_PAYMENT_DATA_ORM";
export const GET_PAYMENT_SUMMARY_ORM = "GET_PAYMENT_SUMMARY_ORM";
export const GET_PAYMENT_SUMMARY_ORM_EXPORT = "GET_PAYMENT_SUMMARY_ORM_EXPORT";
export const GET_PAYMENT_ORM = "GET_PAYMENT_ORM";
export const GET_PAYMENT_ORM_EXPORT = "GET_PAYMENT_ORM_EXPORT";

//Civil
export const GET_CIVIL_DATA_ORM = "GET_CIVIL_DATA_ORM";
export const GET_CIVIL_INITIATION_DATA_ORM = "GET_CIVIL_INITIATION_DATA_ORM";
export const GET_PROJECT_PROGRESS_VIDEO = "GET_PROJECT_PROGRESS_VIDEO";
export const GET_PROJECT_PROGRESS_VIDEO_FILTER_DATE = "GET_PROJECT_PROGRESS_VIDEO_FILTER_DATE";
export const GET_PROJECT_PROGRESS_VIDEO_FILTER_PROJECT =
  "GET_PROJECT_PROGRESS_VIDEO_FILTER_PROJECT";
//Civil Action ORM
export const GET_ACTION_FOR_CIVIL_PROCESS = "GET_ACTION_FOR_CIVIL_PROCESS";
export const GET_ACTION_FOR_CIVIL_INITIATION = "GET_ACTION_FOR_CIVIL_INITIATION";
export const GET_ACTION_FOR_SCHEDULE = "GET_ACTION_FOR_SCHEDULE";
export const GET_ACTION_FOR_BUDGET = "GET_ACTION_FOR_BUDGET";

// Actions
export const GET_ACTION_FOR_HR = "GET_ACTION_FOR_HR";
export const GET_ACTION_FOR_COMPLIANCE = "GET_ACTION_FOR_COMPLIANCE";
export const GET_HR_ORM = "GET_HR_ORM";
export const GET_HR_CLOSED_ORM = "GET_HR_CLOSED_ORM";
export const GET_HR_OPENING_ORM = "GET_HR_OPENING_ORM";
export const GET_ACTION_FOR_APF = "GET_ACTION_FOR_APF";
export const GET_ACTION_FOR_PROJECT_LOAN = "GET_ACTION_FOR_PROJECT_LOAN";
export const GET_APF_TASK_PLAN_REPORT_ORM = "GET_APF_TASK_PLAN_REPORT_ORM";
export const GET_PROJECT_LOAN_SUMMARY_ORM = "GET_PROJECT_LOAN_SUMMARY_ORM";
export const GET_PROCURMENT_PLAN_DATA_ORM = "GET_PROCURMENT_PLAN_DATA_ORM";
export const GET_PROCURMENT_PLAN_ORM = "GET_PROCURMENT_PLAN_ORM";
export const GET_PROCURMENT_PLAN_SUMMARY_ORM = "GET_PROCURMENT_PLAN_SUMMARY_ORM";
export const GET_ACTION_FOR_PROCUREMENT_OUTSTANDING = "GET_ACTION_FOR_PROCUREMENT_OUTSTANDING";
export const GET_SURVEY_SKETCH_DASHBOARD = "GET_SURVEY_SKETCH_DASHBOARD";

export const GET_SITE_INVENTORY_DATA_ORM = "GET_SITE_INVENTORY_DATA_ORM";
export const GET_SITE_INVENTORY_ORM = "GET_SITE_INVENTORY_ORM";
export const GET_ACTION_FOR_SITE_INVENTORY = "GET_ACTION_FOR_SITE_INVENTORY";
export const GET_SITE_INVENTORY_ORM_EXPORT = "GET_SITE_INVENTORY_ORM_EXPORT";
export const GET_PROJECT_LAND_BANK_ORM_EXPORT = "GET_PROJECT_LAND_BANK_ORM_EXPORT";

export const GET_PROJECT_LAND_BANK_DATA_ORM = "GET_PROJECT_LAND_BANK_DATA_ORM";
export const GET_PROJECT_LAND_BANK_DATA_ORM1 = "GET_PROJECT_LAND_BANK_DATA_ORM1";
export const GET_PROJECT_LAND_BANK_ORM = "GET_PROJECT_LAND_BANK_ORM";
export const GET_ACTION_FOR_LAND_BANK_ORM = "GET_ACTION_FOR_LAND_BANK_ORM";

export const GET_APF_TASK_PLAN_QUERY_ORM = "GET_APF_TASK_PLAN_QUERY_ORM";
export const GET_APF_TASK_PLAN_REPORT_ORM_EXPORT = "GET_APF_TASK_PLAN_REPORT_ORM_EXPORT";
export const GET_APF_TASK_PLAN_REPORT_PANEL_ORM = "GET_APF_TASK_PLAN_REPORT_PANEL_ORM";
export const GET_APF_TASK_PLAN_REPORT_BANK_ORM = "GET_APF_TASK_PLAN_REPORT_BANK_ORM";
export const GET_CIVIL_PROJECT_PROGRESS_DATA_ORM = "GET_CIVIL_PROJECT_PROGRESS_DATA_ORM";
export const GET_CIVIL_PROJECT_BUDGET_DATA_ORM = "GET_CIVIL_PROJECT_BUDGET_DATA_ORM";
export const GET_PROJECT_LOAN_DATA_ORM = "GET_PROJECT_LOAN_DATA_ORM";
export const GET_COLLECTION_PROJECTION_DATA_ORM = "GET_COLLECTION_PROJECTION_DATA_ORM";
export const GET_ACTION_FOR_COLLECTION_PROJECTION = "GET_ACTION_FOR_COLLECTION_PROJECTION";
export const GET_COLLECTION_PROJECTION_SUMMARY_ORM = "GET_COLLECTION_PROJECTION_SUMMARY_ORM";
export const GET_COLLECTION_PROJECTION_ORM = "GET_COLLECTION_PROJECTION_ORM";
export const GET_COLLECTION_PROJECTION_ORM_EXPORT = "GET_COLLECTION_PROJECTION_ORM_EXPORT";

//QC
export const GET_QC_ORM = "GET_QC_ORM";
export const GET_QC_ORM_EXPORT = "GET_QC_ORM_EXPORT";
export const GET_ACTION_FOR_QC = "GET_ACTION_FOR_QC";
export const GET_QC_DATA_ORM = "GET_QC_DATA_ORM";
export const GET_QC_SUMMARY_ORM = "GET_QC_SUMMARY_ORM";
//QC New
export const GET_QC_INSPECTION_DATA_ORM = "GET_QC_INSPECTION_DATA_ORM";
export const GET_QC_OBSERVATION_DATA_ORM = "GET_QC_OBSERVATION_DATA_ORM";
export const GET_QC_TRAINING_DATA_ORM = "GET_QC_TRAINING_DATA_ORM";
export const GET_QC_WALKTHROUGH_DATA_ORM = "GET_QC_WALKTHROUGH_DATA_ORM";
export const GET_QC_INSPECTION_ORM = "GET_QC_INSPECTION_ORM";
export const GET_QC_OBSERVATION_ORM = "GET_QC_OBSERVATION_ORM";
export const GET_QC_TRAINING_ORM = "GET_QC_TRAINING_ORM";
export const GET_QC_WALKTHROUGH_ORM = "GET_QC_WALKTHROUGH_ORM";
//Accounts Dashboard
//Admin Expenses
export const GET_ACCOUNT_INVOICE_DATA = "GET_ACCOUNT_INVOICE_DATA";
export const GET_ACCOUNT_INVOICE_SUMMARY = "GET_ACCOUNT_INVOICE_SUMMARY";
export const GET_ACCOUNT_INVOICE = "GET_ACCOUNT_INVOICE";
// Marketing Expenses
export const GET_ACCOUNT_MARKETING_DATA = "GET_ACCOUNT_MARKETING_DATA";
export const GET_ACCOUNT_MARKETING_SUMMARY = "GET_ACCOUNT_MARKETING_SUMMARY";
export const GET_ACCOUNT_MARKETING = "GET_ACCOUNT_MARKETING";
//CRM User Dashboard (User Based Login)
export const GET_CRM_DEPARTMENT_DASHBOARD_DATA = "GET_CRM_DEPARTMENT_DASHBOARD_DATA";
export const GET_CRM_PAYMENT_OUTSTANDING_DATA = "GET_CRM_PAYMENT_OUTSTANDING_DATA";
export const GET_CRM_PAYMENT_OUTSTANDING_SUMMARY = "GET_CRM_PAYMENT_OUTSTANDING_SUMMARY";
export const GET_CRM_PAYMENT_OUTSTANDING_SUMMARY_EXPORT =
  "GET_CRM_PAYMENT_OUTSTANDING_SUMMARY_EXPORT";
export const GET_CRM_PAYMENT_OUTSTANDING_INFO = "GET_CRM_PAYMENT_OUTSTANDING_INFO";
export const GET_CRM_PAYMENT_OUTSTANDING_DETAIL = "GET_CRM_PAYMENT_OUTSTANDING_DETAIL";
export const GET_CRM_PAYMENT_RECEIVABLE_DATA = "GET_CRM_PAYMENT_RECEIVABLE_DATA";
export const GET_CRM_PAYMENT_RECEIVABLE_DETAIL = "GET_CRM_PAYMENT_RECEIVABLE_DETAIL";
export const GET_CRM_PAYMENT_RECEIVED_DATA = "GET_CRM_PAYMENT_RECEIVED_DATA";
export const GET_CRM_PAYMENT_RECEIVED_DETAIL = "GET_CRM_PAYMENT_RECEIVED_DETAIL";
export const GET_CRM_PAYMENT_REFUND = "GET_CRM_PAYMENT_REFUND";
export const GET_CRM_PAYMENT_OUTSTANDING_ITEM = "GET_CRM_PAYMENT_OUTSTANDING_ITEM";

export const GET_PROJECT_PHASE_MILESTONE = "GET_PROJECT_PHASE_MILESTONE";

//PreSales Dashboard (User Based Login)
export const GET_PRESALES_DEPARTMENT_DASHBOARD_DATA = "GET_PRESALES_DEPARTMENT_DASHBOARD_DATA";
export const GET_PRESALES_LEAD_ALLOCATION_DATA = "GET_PRESALES_LEAD_ALLOCATION_DATA";
export const GET_PRESALES_LEAD_ALLOCATION_DATA1 = "GET_PRESALES_LEAD_ALLOCATION_DATA1";
export const GET_PRESALES_LEAD_ALLOCATION_DATA2 = "GET_PRESALES_LEAD_ALLOCATION_DATA2";

export const GET_ACTION_FOR_AUDIT = "GET_ACTION_FOR_AUDIT";
export const GET_APF_DATA_ORM = "GET_APF_DATA_ORM";
export const GET_APF_SUMMARY_ORM = "GET_APF_SUMMARY_ORM";
export const GET_APF_DATA_ORM_FILTER_STATUS = "GET_APF_DATA_ORM_FILTER_STATUS";
export const GET_APF_DATA_ORM_FILTER_PROJECT = "GET_APF_DATA_ORM_FILTER_PROJECT";
export const GET_APF_DATA_ORM_FILTER_TASK = "GET_APF_DATA_ORM_FILTER_TASK";
export const GET_APF_DATA_ORM_EXPORT = "GET_APF_DATA_ORM_EXPORT";
export const GET_HR_DATA_ORM = "GET_HR_DATA_ORM";
export const GET_COMPLIANCE_DATA_ORM = "GET_COMPLIANCE_DATA_ORM";

//Audit
export const GET_AUDIT_DATA_ORM = "GET_AUDIT_DATA_ORM";
export const GET_AUDIT_SUMMARY_ORM = "GET_AUDIT_SUMMARY_ORM";
export const GET_AUDIT_ORM = "GET_AUDIT_ORM";

//ERP
export const GET_ERP_DATA_ORM = "GET_ERP_DATA_ORM";
export const GET_ERP_SUMMARY_ORM = "GET_ERP_SUMMARY_ORM";
export const GET_ERP_ORM = "GET_ERP_ORM";
